import {useEffect} from 'react';
import {ErrorBoundary} from 'react-error-boundary';
import {useDispatch} from 'react-redux';
import {useLocation} from 'react-router';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

import {LoggingActions} from '@/constants/loggingActions';

import {logError} from './redux/slice';

// @ts-ignore
import styles from './styles.module.scss';

type ErrorPageProps = {
    error: Error;
    errorData?: Record<string, unknown>;
};

const ErrorPage = ({error, errorData}: ErrorPageProps) => {
    const dispatch = useDispatch();
    const location = useLocation();

    useEffect(() => {
        dispatch(
            logError({
                url: location.pathname,
                actionName: LoggingActions.pageCrashError,
                message: error,
                ...errorData,
            }),
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className={styles.error}>
            <ErrorOutlineIcon className={styles.errorIcon} />
            <div className={styles.errorText}>Something went wrong</div>
        </div>
    );
};

const ErrorBoundaryComponent = ({
    children,
    errorData,
}: {
    children: React.ReactNode;
    errorData?: Record<string, unknown>;
}) => (
    <ErrorBoundary FallbackComponent={(props) => <ErrorPage errorData={errorData} {...props} />}>
        {children}
    </ErrorBoundary>
);

export default ErrorBoundaryComponent;
